module.exports = __webpack_public_path__ + "img/ico-local.b3ee0100.svg";